/* eslint-disable  */
import React, { useEffect } from "react";
// import { PaymentStatus } from '../../common/components/digital-gold/PaymentStatus';
// import {useBuyVerifyStore} from '../../api/digital-gold/store/buyVerifyStore';
import { useBuyStatus } from "@/api/digital-gold/buyConfirm";
import type { BuyConfirmResponseData } from "@/api/digital-gold/store/buyConfirmStore";
import { useBuyConfirmStore } from "@/api/digital-gold/store/buyConfirmStore";
import { useBuyVerifyStore } from "@/api/digital-gold/store/buyVerifyStore";
import { PaymentStatus } from "@/common/components/digital-gold";
import type { PaymentStatusProp } from "@/common/components/digital-gold/PaymentStatus";
import { createMoengageEvent } from "@/utils/moengage";
import useMoengageStore from "@/store/moengage";
import moment from "moment";

export const BuyPaymentScreen = () => {
  const [verifyData] = useBuyVerifyStore((state) => [state.verifyData]);
  const { data } = useBuyStatus({ product: "DG", id: verifyData?.buyLotId });
  const resultData: BuyConfirmResponseData | undefined =
    data && data.data && data.data.data ? data.data.data : undefined;
  const [confirmData] = useBuyConfirmStore((state) => [state.confirmData]);
  const [dgTransactionSuccessful, nonInvoiceBalance, invoiceBalance] = useMoengageStore((state) => [state.dgTransactionSuccessful, state.nonInvoiceBalance, state.invoiceBalance])

  useEffect(()=>{
    createMoengageEvent(dgTransactionSuccessful,{
      total_amount: verifyData.totalAmount,
      gst: verifyData.gst,
      net_amount: verifyData.payableAmount,
      created_date: moment().format('MMMM Do YYYY, h:mm:ss a'),
      service_type: 'dg',
      transaction_status : resultData?.status,
      active_dg_weight: Number.parseFloat(nonInvoiceBalance) + invoiceBalance,
    })
  },[data])

  let statusProps: PaymentStatusProp = {
    amount: 0,
    goldValue: 0,
    payableAmount: 0,
    weight: 0,
    transactionId: "",
    gst: 0,
    status: "in_progress",
    appliedCoupon: null,
    couponValue: 0,
    successMessage: "",
    failureMessage: "",
    inprogressMessage: "",
    flowType: "Buy",
  };
  const resultAmount = verifyData.appliedCouponCodes !== null ? (Number(verifyData.promoCodeDiscountAmount) + Number(resultData?.finalAmount)) : Number(resultData?.finalAmount)
  // const resultAmount = (Number(statusProps.couponValue) + Number(resultData?.finalAmount))
  if (resultData != undefined) {
    const amount =
      verifyData.payableAmount === 0
        ? confirmData.goldValue
        : resultAmount;
    const goldValue =
      verifyData.payableAmount === 0
        ? confirmData.goldValue
        : resultAmount;

    statusProps = {
      amount,
      goldValue: resultData.goldValue,
      payableAmount: verifyData.payableAmount,
      weight: resultData.weight,
      transactionId: resultData.transactionId,
      gst: verifyData.gst,
      status: resultData.status,
      appliedCoupon: verifyData.appliedCouponCodes,
      couponValue: verifyData.promoCodeDiscountAmount,
      successMessage: "Gold Purchase Successful",
      failureMessage: "Gold Purchase Failed",
      inprogressMessage: "Gold Purchase In Progress",
      flowType: "Buy",
    };
  }
  return <PaymentStatus {...statusProps} />;
};
